// integration date 26/06/2025

// sign up
export const get_CountryCode_Dropdown_Data = "get_CountryCode_Dropdown_Data";
export const post_SignUp_Data = "post_SignUp_Data";
export const google_SignUp_Login = "google_SignUp_Login";
// sign up

// sign in
export const post_SignIn_Data = "post_SignIn_Data";
export const get_Generated_Token = "get_Generated_Token";
export const validate_Generated_Token = "validate_Generated_Token";
// sign in

// Dashboard pages
export const get_counts = "get_counts";
export const get_count_userwise = "get_count_userwise";
export const get_subscription = "get_subscription";
export const get_login_details = "get_login_details";
export const get_user_activity = "get_user_activity";
export const get_download_activity = "get_download_activity";
export const get_country_graph = "get_country_graph";
export const get_map_graph = "get_map_graph";
export const get_industry_graph = "get_industry_graph";
export const get_recent_search = "get_recent_search";
export const get_credits = "get_credits";
export const get_Upload_Stats_BarChart_Data = "get_Upload_Stats_BarChart_Data";
// Dashboard pages

// #region upload page api's
export const get_upload_details = "get_upload_details";
// #endregion upload page

// search contacts
export const get_JobLevel_Dropdown = "get_JobLevel_Dropdown";
export const get_preJobLevel_Dropdown = "get_preJobLevel_Dropdown";
export const get_Job_Function_Dropdown = "get_Job_Function_Dropdown";
export const get_Technology_Dropdown = "get_Technology_Dropdown";
export const get_previousTechnology_Dropdown = "get_previousTechnology_Dropdown";
export const get_SubIndustries_Dropdown = "get_SubIndustries_Dropdown";
export const get_previousSubIndustry_Dropdown = "get_previousSubIndustry_Dropdown";
export const get_CountryName_Dropdown = "get_CountryName_Dropdown";
export const get_Searched_Contact_Data = "get_Searched_Contact_Data";
export const get_StateDropdown_BasedOnCountry = "get_StateDropdown_BasedOnCountry";
export const get_CityDropdown_BasedOnState = "get_CityDropdown_BasedOnState";
export const get_Search_Contact_Data = "get_Search_Contact_Data";
export const post_Search_Data_Count = "post_Search_Data_Count";
export const post_Phone_Unlock_Data = "post_Phone_Unlock_Data"
export const get_Phone_Email_Unlocked_Data = "get_Phone_Email_Unlocked_Data";
export const get_List_Name = "get_List_Name";
export const post_Save_Search_Data = "post_Save_Search_Data";
export const get_Continent_Dropdown = "get_Continent_Dropdown";
// search contacts

// Viewed Contacts
export const get_Viewed_Contacts_Data = "get_Viewed_Contacts_Data";
export const download_Viewed_Contacts_Data = "download_Viewed_Contacts_Data";
export const post_Delete_Viewed_Contacts_Data = "post_Delete_Viewed_Contacts_Data";
export const unlock_All_Contacts = "unlock_All_Contacts";
// Viewed Contacts

// Settings Trash
export const get_Trashed_Data = "get_Trashed_Data";
export const restore_All_Data = "restore_All_Data";
export const delete_trashed_Data = "delete_trashed_Data";
// Settings Trash

// Saved Searches
export const get_Saved_Searches_Data = "get_Saved_Searches_Data";
export const edit_Saved_Searches_Data = "edit_Saved_Searches_Data";
export const delete_Saved_Searches_Data = "delete_Saved_Searches_Data";
// Saved Searches

// Settings Users
export const get_Users_Data = "get_Users_Data";
// Settings Users

// Report
// Data Count
export const get_Report_Country_Data_Count = "get_Report_Country_Data_Count";
export const get_Report_Industry_Data_Count = "get_Report_Industry_Data_Count";
export const get_Industry_Dropdown = "get_Industry_Dropdown";
// Data Count
// Report

// Total Data Count
export const Get_Total_Data_Count = "Get_Total_Data_Count";
export const post_Users_Data = "post_Users_Data";
// Total Data Count

// #region Upload data page
export const Get_Upload_Report = "Get_Upload_Report";
export const get_upload_user = "get_upload_user";
// #endregion

// Reset Password
export const post_Reset_Password_Data = "post_Reset_Password_Data";
// Reset Password

// Forgot Password
export const send_Forgot_Password_Email = "send_Forgot_Password_Email";
// Forgot Password

// Profile
export const get_Profile_Data = "get_Profile_Data";
export const post_Profile_Data = "post_Profile_Data";
// Profile

// My List
export const get_My_List_Data = "get_My_List_Data";
export const update_My_List_Data = "update_My_List_Data";
export const delete_My_List_Data = "delete_My_List_Data";
// My List

// Request APIs
// Request API
export const get_Request_Data = "get_Request_Data";
export const post_Request_Data = "post_Request_Data";

export const get_Response_Data = "get_Response_Data";
export const post_Response_Data = "post_Response_Data";

// Optionally for API status
export const request_Loading = "request_Loading";
export const request_Success = "request_Success";
export const request_Error = "request_Error";
export const request_Post_Success = "request_Post_Success";

// GET
export const get_Request_Start = "get_Request_Start";
export const get_Request_Success = "get_Request_Success";
export const get_Request_Failure = "get_Request_Failure";

// POST
export const post_Request_Start = "post_Request_Start";
// export const post_Request_Data = "post_Request_Data";
export const post_Request_Failure = "post_Request_Failure";

// REVIEW (Pending → Reviewed)
export const update_Request_Review_Start = "update_Request_Review_Start";
export const update_Request_Review = "update_Request_Review";
export const update_Request_Review_Failure = "update_Request_Review_Failure";

// COMPLETE (Reviewed → Completed)
export const update_Request_Complete_Start = "update_Request_Complete_Start";
export const update_Request_Complete = "update_Request_Complete";
export const update_Request_Complete_Failure = "update_Request_Complete_Failure";

